module.exports = __webpack_public_path__ + "img/sort／phone／IO@2x.310c1cc9.png";